module.exports = __webpack_public_path__ + "static/media/CareerFounder-Final-A4.82ed8501.pdf";